import { Severity } from '../../../../shared/fn-ui-icons/fn-ui-severity-icon/enums/severity.enum';

export const EXTERNAL_SEVERITY = {
  3: Severity.LOW,
  5: Severity.MEDIUM,
  9: Severity.CRITICAL
};
